/**
 * <WebFrame> au web : la page dans une iframe, au même cadre que la WebView du téléphone.
 * Le contrat est dans `WebFrame.tsx`.
 */
import React, { useState } from "react"
import { View } from "react-native"

import { WaitingText } from "../../atoms/WaitingText"
import { webFrameStyles } from "./webFrameStyles"
import { type WebFrameProps } from "./WebFrame"

export type { WebFrameProps } from "./WebFrame"

export function WebFrame(props: WebFrameProps) {
    const { url, height, title, loadingLabel, testID } = props
    const [loaded, setLoaded] = useState(false)
    return (
        <View style={webFrameStyles.frame(height)} testID={testID}>
            <iframe src={url} title={title} style={IFRAME_STYLE} onLoad={() => setLoaded(true)} />
            {!loaded && (
                <View style={webFrameStyles.waiting} pointerEvents="none">
                    <WaitingText color="text-muted">{loadingLabel}</WaitingText>
                </View>
            )}
        </View>
    )
}

/** Un style DOM : l'iframe n'est pas une vue React Native, Unistyles ne la style pas. */
const IFRAME_STYLE = { width: "100%", height: "100%", border: "none" } as const
